import { WsEvent } from '@ts-ws/enums'

import { useAssessmentsStore } from '@stores/assessments'

import { useActiveKidDisciplinesApi } from '@api/kids/active-kid-disciplines.hook'
import { onDisciplineReady } from '@hooks/discipline/on-discipline-ready.hook'
import { useKidRoutes } from '@composables/routes/kid-route.hook'

export const useListenEventAssessment = (channel: any): void => {
  const assessmentsStore = useAssessmentsStore()

  const { isRouteHome } = useKidRoutes()

  onDisciplineReady(() => {
    if (isRouteHome.value) {
      channel.listen(WsEvent.AssessmentCreated, async (): Promise<void> => {
        void useActiveKidDisciplinesApi()
        assessmentsStore.refreshNow()
      })
    }
  })
}
